import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'deleteStream';
export const useDeleteStreamTranslation = (): UseTranslationResponse<'features', typeof keyPrefix> => useTranslation('features', { keyPrefix });

export const ruRu = (__LOCALE_RU__ ? ({
  [keyPrefix]: {
    title: 'Удалить',
    on_success: 'Источник удалён',
    on_error: 'Не удалось удалить источник',
    confirmation: {
      title: 'Удаление источника',
      subtitle: 'Источник будет удалён безвозвратно',
      buttons: {
        cancel: 'Отмена',
        delete: 'Удалить',
      },
    },
  },
}) : {}) as Record<string, unknown>;

export const en = (__LOCALE_EN__ ? ({
  [keyPrefix]: {
    title: 'Delete',
    on_success: 'Source deleted',
    on_error: 'Failed to delete source',
    confirmation: {
      title: 'Delete source',
      subtitle: 'The source will be permanently deleted',
      buttons: {
        cancel: 'Cancel',
        delete: 'Delete',
      },
    },
  },
}) : {}) as Record<string, unknown>;

export const esEs = (__LOCALE_ESES__ ? ({
  [keyPrefix]: {
    title: 'Eliminar',
    on_success: 'Fuente eliminada',
    on_error: 'No se pudo eliminar la fuente',
    confirmation: {
      title: 'Eliminar fuente',
      subtitle: 'La fuente se eliminará de forma permanente',
      buttons: {
        cancel: 'Cancelar',
        delete: 'Eliminar',
      },
    },
  },
}) : {}) as Record<string, unknown>;

export const ptBr = (__LOCALE_PTBR__ ? ({
  [keyPrefix]: {
    title: 'Excluir',
    on_success: 'Fonte excluída',
    on_error: 'Falha ao excluir fonte',
    confirmation: {
      title: 'Excluir fonte',
      subtitle: 'A fonte será excluída permanentemente',
      buttons: {
        cancel: 'Cancelar',
        delete: 'Excluir',
      },
    },
  },
}) : {}) as Record<string, unknown>;
